import * as React from "react"
import { router } from "@inertiajs/react"
import { Trash2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

// "Remove" with a confirmation (M7): the design system's Modal, the
// confirmation-prompt case. The DELETE goes through Inertia's router and the
// server redirects to the list with a notice. The dialog closes before the
// request, so the row it belongs to can disappear cleanly.
export function ConfirmDestroy({
  url,
  itemName,
  title,
  description,
  confirmLabel = "Remove",
}: {
  url: string
  /** Names the trigger for assistive tech: "Remove West Midlands Golf Club". */
  itemName: string
  title: string
  description: React.ReactNode
  confirmLabel?: string
}) {
  const [open, setOpen] = React.useState(false)
  const [processing, setProcessing] = React.useState(false)

  const confirm = () => {
    setOpen(false)
    router.delete(url, {
      preserveScroll: true,
      onStart: () => setProcessing(true),
      onFinish: () => setProcessing(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="lg" disabled={processing}>
          <Trash2 className="h-4 w-4" aria-hidden="true" />
          <span>
            {processing ? "Removing…" : "Remove"}
            <span className="sr-only"> {itemName}</span>
          </span>
        </Button>
      </DialogTrigger>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost" size="lg">
              Cancel
            </Button>
          </DialogClose>
          <Button variant="danger" size="lg" onClick={confirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
